import React from "react";

const PrivacyPolicy = () => {
    return (
        <div>
            <div className="row">
                <div className="offset-1 col-10 text-left my-5">
                    <span className="d-block mb-3">
                        Effective June 1, 2020
                    </span>
                    <span className="d-block mb-3">
                        At Secure the Bag – referred to as “STB”, we’re committed to protecting your privacy and
                        collecting only the minimum amount of info needed to provide our software and services —
                        referred to as “Services”.
                        Your use of the Services indicates you agree to this policy and our <a href="/rules/terms" target="_blank"
                            className="app-link">
                            terms of use.
                        </a>
                    </span>

                    <span className="font-28 d-block mt-5 mb-3">Summary</span>
                    <span className="d-block mb-3">
                        The policy below centers around the following statements:
                    </span>
                    <ol>
                        <li>We do not collect personal information, including your IP address, other than information you voluntarily provide.</li>
                        <li>We do not sell your personal info to advertisers or other third parties.</li>
                        <li>In the event you do voluntarily provide personal information, we do not retain your personal info for no more than 30 days after you request deletion.</li>
                    </ol>

                    <span className="font-28 d-block mt-5 mb-3">Complete terms</span>
                    <span className="d-block mb-3">
                        As used in this policy, “Personal Info” is data that can identify a particular person or device.
                        Aggregate data is not considered Personal Info, as there is no association back to a particular person.
                    </span>
                    <span className="d-block mb-3">
                        Our recommendation to all users is to use a secondary email address or social media account (e.g. Twitter
                        or Google) that has no direct attribution or Personal Info to access our Services.
                    </span>
                    <span className="d-block mb-3">
                        Why? We need your email address or social media log-in to create an account on STB.
                    </span>
                    <span className="d-block mb-3">
                        By using the Twitter or Google social log-in feature, you must fully comply with and respect Twitter and
                        Google’s Terms of Service, which can be read in full here: <a href="https://twitter.com/tos" target="_blank">
                            https://twitter.com/tos</a> and <a href="https://policies.google.com/terms" target="_blank">
                            https://policies.google.com/terms</a>
                    </span>
                    <span className="d-block mb-3">
                        If at any time you wish for us to copy, modify or remove your information, you may do so by sending us an
                        email through <a href="mailto:support@securethebag.io">support@securethebag.io</a>. Or you may update your email address via your account settings.
                    </span>

                    <span className="font-22 d-block mt-5 mb-3">1. STB never collects your Personal Info except to communicate with you</span>
                    <span className="d-block mb-3">
                        Our Services do not collect any of your Personal Info. Unlike most websites, our site also does not collect
                        your IP address. We do detect non-personally identifiable geo-location information to optimize our services,
                        but we definitely do not collect your precise geo-location or associate geo-location information with a
                        particular user.
                    </span>
                    <span className="d-block mb-3">
                        Because we do not collect information about your online activities over time and across third-party websites
                        or online services, there is no need for us to respond to a browser’s Do Not Track settings, although we
                        strongly support a consumer’s right to set such a preference and encourage all website operators to honor
                        this consumer choice.
                    </span>
                    <span className="d-block mb-3">
                        We may request your email address or a username to communicate with you. This info is used only as you’d
                        expect and deleted upon request.
                    </span>
                    <span className="d-block mb-3">
                        Your billing information is stored in BrainTree. BrainTree offers the following <a
                            href="https://www.braintreepayments.com/features/payment-methods" target="_blank">payment methods</a>:
                        Apple Pay, Google Pay, PayPal, Venmo, and Credit/Debit Cards. STB recommends using payment methods that do
                        not directly tie you to your Personal Info to protect your personal privacy.
                    </span>
                    <span className="d-block mb-3">
                        Your payment information and email address is subject to BrainTree’s <a
                            href="https://www.braintreepayments.com/legal/braintree-privacy-policy" target="_blank">privacy policy</a>.
                    </span>
                    <span className="d-block mb-3">
                        To improve the Services and your experience on our site, we may collect aggregate usage data from the
                        Services and our website, including number of page views, visitor browser types, operating systems, or the
                        links clicked to navigate to and from our site. Our cookies do not track you. Most browsers allow you to
                        refuse cookies or disable them, you can find out more here. Or check your browser preferences.
                    </span>

                    <span className="font-22 d-block mt-5 mb-3">2. STB never sells your email address or any other Personal Info you volunteer</span>
                    <span className="d-block mb-3">
                        We do not receive payment in cash or in kind from third parties in exchange for your Personal Info.
                        Further, we do not allow third parties to collect info about you on our site through cookies or other means.
                    </span>

                    <span className="font-22 d-block mt-5 mb-3">3. STB retains the Personal Info you volunteer for one month or less</span>
                    <span className="d-block mb-3">
                        We remove your Personal Info from our records within 30 days of any request to do so. Again, this
                        is only if you voluntarily provide us your Personal Info – we will never ask for this information nor
                        do we want your Personal Info.
                    </span>

                    <span className="font-22 d-block mt-5 mb-3">4. CCPA and GDPR</span>
                    <span className="d-block mb-3">
                        Certain privacy laws around the world, including the European General Data Protection Regulation (GDPR)
                        and the California Consumer Privacy Act (CCPA), provide users with rights related to their personal
                        information. Consistent with those laws, STB gives you the choice of accessing, editing, or removing
                        certain information, as well as choices about how we contact you. You may change or correct your STB
                        account information through your account settings. You can also request to permanently close your account
                        and delete linkage to your email address and/or social media log-in. Depending on your location, you may
                        also benefit from a number of rights with respect to your information. While some of these rights apply
                        generally, certain rights apply in limited cases.
                    </span>
                    <ul>
                        <li>
                            <b>Right to Access & Portability</b>: You can access certain information associated with your account
                            by visiting your account settings. You can request a copy of your information in an easily accessible
                            format and information explaining how that information is used.
                        </li>
                        <li>
                            <b>Right to Correction</b>: You have the right to request that we rectify inaccurate information about
                            you. By visiting your account settings, you can correct and change certain your email address and other
                            non-personal information associated with your account.
                        </li>
                        <li>
                            <b>Right to Deletion</b>: You have the right to request the deletion of your information.
                        </li>
                        <li>
                            <b>Right to Object</b>: If we process your information based on our legitimate interests as explained above,
                            you can object to this processing in certain circumstances. In such cases, we will cease processing your
                            information unless we have compelling legitimate grounds to continue processing or where it is needed for
                            legal reasons. Where we use your personal data for direct marketing purposes, you can object using the
                            unsubscribe link in such communications or changing your account email settings.
                        </li>
                        <li>
                            <b>Right to Withdraw Consent</b>: Where we rely on consent, you can choose to withdraw your consent
                            to our processing of your information using specific features provided to enable you to withdraw
                            consent, like an email unsubscribe link. This is without prejudice to your right to generally
                            permanently close your account and delete your account information.
                        </li>
                    </ul>

                    <span className="d-block mb-3">
                        The CCPA provides California residents with the following additional rights:
                    </span>
                    <ul>
                        <li>
                            <b>Right to Know</b>: California residents may request disclosure of the specific pieces and/or
                            categories of personal information that the business has collected about them, the categories of
                            sources for that personal information, the business or commercial purposes for collecting the
                            information, the categories of personal information that we have disclosed, and the categories
                            of third parties with which the information was shared. Again, while we do not collect Personal
                            Info, you are entitled to request disclosure regardless, in compliance with the CCPA.
                        </li>
                        <li>
                            <b>Right to Opt-Out</b>: To the extent that STB “sells” personal information (as that term is defined
                            under the CCPA), California residents are entitled to opt-out of the “sale” of data at any time (see
                            below for more information). Once again, while we do not collect Personal Info, we are obligated to
                            disclose this right under the CCPA.
                        </li>
                        <li>
                            If you would like to manage or change your account information, you can do so via your STB account
                            settings. Alternatively, if you would like to permanently delete your account, you may exercise your
                            right by submitting a request at <a href="mailto:support@securethebag.io">support@securethebag.io</a>.
                        </li>
                        <li>
                            STB will never discriminate against you for exercising any of your rights, including otherwise denying
                            you goods or services, providing you with a different level or quality of services, or charging you
                            different prices or rates for services. If you need further assistance, you can contact STB via email
                            at <a href="mailto:support@securethebag.io">support@securethebag.io</a>.
                        </li>
                    </ul>

                    <span className="font-28 d-block mt-5 mb-3">Changes to this policy</span>
                    <span className="d-block mb-3">
                        We may make small, inconsequential changes to this policy with or without notice to you, so you’re
                        encouraged to review the policy from time to time. Substantive changes to this policy will be emailed
                        to users who submit a request to <a href="mailto:support@securethebag.io">support@securethebag.io</a>.
                    </span>

                    <span className="font-28 d-block mt-5 mb-3">Contact</span>
                    <span className="d-block mb-3">
                        You can contact us at <a href="mailto:support@securethebag.io">support@securethebag.io</a> if you have
                        any questions about this policy.
                    </span>

                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
